module.exports = __webpack_public_path__ + "img/social-tw.a58dd175.svg";